import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-arrow-left",
  "use": "icon-icon-arrow-left-usage",
  "viewBox": "0 0 20.218 12.419",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.218 12.419\" id=\"icon-icon-arrow-left\">\n    <path id=\"icon-icon-arrow-left_Path_35\" data-name=\"Path 35\" d=\"M10.83,0V5.488H0V6.932H10.83v5.486l9.388-6.209Z\" transform=\"translate(20.218 12.418) rotate(180)\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol